query AssistantConversation($id: ID!) {
  assistantConversation(id: $id) {
    id
    title
    topic
    hasRequest
    createdAt
    lastMessageAt
    messageCount
    utm {
      source
      medium
      campaign
      content
      term
      link {
        id
        title
        deleted
      }
      email {
        kind
        automationId
        automationName
        nodeId
        template
      }
      capturedAt
      backfilled
    }
    user {
      id
      email
    }
    messages {
      id
      role
      kind
      text
      createdAt
    }
  }
}
